"use strict";

import angular from "angular";

import template from "./button-share-report.component.html";
import "./button-share-report.component.scss";

import _ from "lodash";

import { Company } from "../../../gateway/Company/Company";
import { Report } from "../../../gateway/Report/Report";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import { EventScoreService } from "../../../presentation/services/Score/event-score.service";
import { ShareHistory } from "../../../presentation/services/ShareHistory/ShareHistory";
import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";
import { GetUserUsecase } from "../../../usecases";
import { AnonymousUser } from "../../../utils/users-roles/users-roles";
import {
    dialogContainerShareTemplate,
    dialogShareTemplate,
    nextLevelMissionNucontTemplate
} from "../../../views/accounting/company/reports/reports.dialog-templates";
import "../../../views/accounting/company/reports/reports-list/dialogs/dialog-container-share/dialog-container-share.controller";
import "../../../views/accounting/company/reports/reports-list/dialogs/dialog-share/dialog-share.controller";
import "../../../views/accounting/company/reports/dialogs/next-level-mission-nucont/next-level-mission-nucont.controller";
import feedbackPerfomanceTemplate from "../../dialogs/feedback-perfomance/feedback-perfomance.html";
import toastCustomTemplate from "../nu-toast-custom/toast-custom.component.html";

export class buttonShareComponent {
    constructor($mdDialog, DSNDialogService, toast, $stateParams, $state) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.toast = toast;
        this.$stateParams = $stateParams;
        this.$state = $state;

        this.Events = new Events();
        this.Report = new Report();
        this.ShareHistory = new ShareHistory({ Report: this.Report });
        this.user = new UserDataAdapter().user();
        this.User = new User();
        this.controllerPop = {
            enabled: false,
            feedback: true
        };
        this.Company = new Company();
        this.EventScore = new EventScoreService();

        this.controllerFeedBack = {};

        this.defaultFeedback = angular.copy(this.controllerFeedBack);
        this.scoreMessage = 0;
    }

    $onInit() {
        this.showConfigReports =
            new UserDataAdapter().user().username != AnonymousUser.email;
        this.reportListLink = this.$state.href(
            "nucont.accounting.reporting-center.generateds",
            {
                id: this.companyData._id,
                accountingId: this.accountingId,
                openConfig: 0
            }
        );
        this.Events.setParamns({
            companyId: this.companyData._id
        });
        this._onInitController();
        this.verifyFeedback(this.hideFeedback, this.showReport);
    }

    _onInitController() {
        const imageStar = "/assets/images/starcolorless.svg";
        const user = {
            score: 0,
            comment: "",
            userId: "",
            opinion: [],
            date: "",
            presentation: {
                comment: "",
                score: ""
            }
        };

        this.controllerFeedBack = {
            messages: [
                {
                    text: "Do que você não gostou?",
                    stars: [0, 1, 2]
                },
                {
                    text: "O que pode melhorar?",
                    stars: [3]
                },
                {
                    text: "Do que você gostou?",
                    stars: [4, 5]
                }
            ],
            stars: [
                {
                    actived: false,
                    imageStar,
                    tooltip: "Muito ruim"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Ruim"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Regular"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Bom"
                },
                {
                    actived: false,
                    imageStar,
                    tooltip: "Muito bom"
                }
            ],
            chips: [
                "Resultados",
                "Encargos",
                "Gastos",
                "Estou com dúvidas",
                "Quero marcar uma reunião"
            ],
            user,
            defaultData: angular.copy(user)
        };
    }
    messageFeedback() {
        return this.controllerFeedBack.messages.find(
            (s) =>
                s.stars.find((n) => n === this.scoreMessage) ===
                this.scoreMessage
        ).text;
    }

    hasStarred() {
        return this.controllerFeedBack.stars.filter((s) => s.actived).length;
    }

    selectStar(score) {
        this.setStars(score);
        this.scoreMessage = this.hasStarred();

        this.controllerFeedBack.user.score = score + 1;
    }

    setStars(number) {
        if (this.controllerFeedBack.stars[number].actived) {
            for (let r = number; r < this.controllerFeedBack.stars.length; r++)
                this.controllerFeedBack.stars[r].actived = false;

            return;
        }

        for (let i = 0; i < number + 1; i++)
            this.controllerFeedBack.stars[i].actived = true;
    }

    hasChipped(chipName) {
        return this.controllerFeedBack.user.opinion.find((c) => c === chipName)
            ? true
            : false;
    }

    addChip(chipName) {
        if (this.controllerFeedBack.user.opinion.find((c) => c === chipName))
            return this.controllerFeedBack.user.opinion.splice(
                this.controllerFeedBack.user.opinion.indexOf(chipName),
                1
            );

        this.controllerFeedBack.user.opinion.push(chipName);
    }

    async onSendFeedaback(sendDelivery) {
        this.loading = true;
        let userIdentify = {};
        if (this.$state.params.userIdentify) {
            const response = await this.User.getByIds([
                this.$state.params.userIdentify
            ]);
            userIdentify = response[0];
        }
        this.controllerFeedBack.user.date = new Date();
        this.controllerFeedBack.user.userId = userIdentify._id || this.user._id;
        this.controllerFeedBack.user.name =
            userIdentify?.profile?.nickname ||
            userIdentify?.profile?.name ||
            this.anonymousUser.name ||
            this.user.profile?.nickname ||
            this.user.profile?.name;

        this.controllerFeedBack.user.username =
            userIdentify?.username ||
            this.anonymousUser.email ||
            this.user.username;

        try {
            this.afterSend();
            const { response } = await this.Report.updateOne(
                this.$stateParams.reportId,
                {
                    feedback: this.controllerFeedBack.user
                }
            );
            this._sendFeedbackEmail({
                reportId: this.report._id,
                feedback: angular.copy(this.controllerFeedBack),
                index: response?.value?.feedbacks?.length
                    ? response?.value?.feedbacks?.length - 1
                    : 0,
                sendDelivery
            });
            this.controllerFeedBack = this.defaultFeedback;
            this.controllerPop.feedback = false;
            this.$mdDialog.hide();
        } catch (ex) {
            console.error(ex);
        } finally {
            this.loading = false;
        }
    }

    showToastGenerated() {
        this.toast.show("", "bottom right", {
            hideDelay: 1000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Feedback enviado com sucesso!",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    async _sendFeedbackEmail({ reportId, feedback, index, sendDelivery }) {
        const emails = [];
        const [sharedBy] = await this.User.getByIds([this.report.userId]);
        const defaultData = {
            to: {
                email: sharedBy.username,
                name:
                    _.get(sharedBy, "profile.nickname") ||
                    _.get(sharedBy, "profile.name")
            },
            from: {
                name: "Nucont",
                email: "naoresponda@nucont.com"
            }
        };
        const urlPro = `${publicSettings.url}/contabilidade/${this.$stateParams.accountingId}/empresa/${this.companyData._id}/meus-relatorios?report=${reportId}&feedbackIndex=${index}`;
        emails.push({
            template_id: "d-dfb934d63c9f4e368a0e6fe4f8fc9a02",
            customData: {
                userName:
                    _.get(sharedBy, "profile.nickname") ||
                    _.get(sharedBy, "profile.name"),
                company: {
                    name: this.companyData.name,
                    userName: feedback.user.name,
                    logo: this.companyData.picture || ""
                },
                score: feedback.user.score,
                badges: feedback.user.opinion,
                comment: feedback.user.comment,
                urlPro: `${urlPro}&feedbackType=performance`,
                subject: `[${this.companyData.name}] Novo Feedback de Performance!`
            },
            ...defaultData
        });
        if (sendDelivery) {
            emails.push({
                template_id: "d-81e5e0fae623460ea63e61b0e7a19569",
                customData: {
                    userName:
                        _.get(sharedBy, "profile.nickname") ||
                        _.get(sharedBy, "profile.name"),
                    company: {
                        userName: feedback.user.name,
                        logo: this.companyData.picture || ""
                    },
                    score: _.get(feedback, "user.presentation.score"),
                    comment: _.get(feedback, "user.presentation.comment"),
                    urlPro: `${urlPro}&feedbackType=delivery`,
                    subject: `[${this.companyData.name}] Novo Feedback de Entrega!`
                },
                ...defaultData
            });
        }
        try {
            this.showToastGenerated();
        } catch (error) {
            console.error("error", error);
            this.showToastError();
        }
    }

    showToastError() {
        this.toast.show("", "bottom right", {
            hideDelay: 3000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Falha ao enviar email.",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    /**
     * @private
     * @param {string} userId
     * @returns {Promise<Boolean>}
     */
    async _onPushSharedReport(userId) {
        await this.Report.updateOne(
            _.get(this.report, "_id"),

            {
                shared: [userId]
            }
        );

        return true;
    }
    openFeedbackPerfomance() {
        this.controllerPop.feedback = false;

        if (new UserDataAdapter().user().username == AnonymousUser.email) {
            this.Events.send(
                `Relatorio.Feedback.anonimo.Performace.${SourceConvert.toHuman(
                    this.report.sources
                )}`,
                {
                    username: this.anonymousUser.email,
                    roles: "Anonimo",
                    profile: {
                        accountingId: this.accountingId
                    }
                }
            );
        } else {
            this.Events.send(
                `Relatorio.Feedback.Performace.${SourceConvert.toHuman(
                    this.report.sources
                )}`
            );
        }

        this.DSNDialogService.custom({
            clickOutsideToClose: false,
            controller: "FeedbackPerfomanceCtrl as $ctrl",
            locals: {
                action: {
                    send: async (presentation) => {
                        if (
                            new UserDataAdapter().user().username ==
                            AnonymousUser.email
                        ) {
                            this.Events.send(
                                `Relatorio.Feedback.anonimo.Presentation.${SourceConvert.toHuman(
                                    this.report.sources
                                )}`,
                                {
                                    username: this.anonymousUser.email,
                                    roles: "Anonimo",
                                    profile: {
                                        accountingId: this.accountingId
                                    }
                                }
                            );
                        } else {
                            this.Events.send(
                                `Relatorio.Feedback.Presentation.${SourceConvert.toHuman(
                                    this.report.sources
                                )}`
                            );
                        }

                        this.controllerFeedBack.user.presentation =
                            presentation;
                        await this.onSendFeedaback(true);

                        this.$mdDialog.hide();
                        this._onInitController();
                        return true;
                    }
                },
                width: "388px",
                templateHtml: feedbackPerfomanceTemplate
            },
            after: {
                hide: (response) => {},
                cancel: async () => {
                    await this.onSendFeedaback(false);
                    this._onInitController();
                }
            }
        });
    }

    openShareEmail() {
        this.DSNDialogService.custom({
            clickOutsideToClose: false,
            controller: "DialogShareCtrl as $ctrl",
            locals: {
                action: {
                    shared: () => (this.historyShared = true)
                },
                width: "674px",
                report: this.report,
                title: "Compartilhar por Email",
                accountingId: this.accountingId,
                company: this.companyData,
                templateHtml: dialogShareTemplate
            },
            after: {
                hide: (response) => {
                    this.EventScore.onReportShared(
                        this.accountingId,
                        this.companyData._id,
                        this.report.sources
                    );

                    this.missionLevelUpDialog();
                }
            }
        });
    }

    async updateImpact() {
        // await this.Company.updateImpact(this.companyData._id, {
        //     status: "Impactada",
        //     lastSharedReport: new Date()
        // });
    }

    missionLevelUpDialog() {
        if (!this.EventScore._isAccountingUser()) return;
        if (
            this.engagement?.companiesIdsImpactInCurrentDate.includes(
                this.companyData._id
            )
        )
            return;
        const engagementNextLevel = {
            Bronze: {
                label: "Prata",
                total: 11
            },
            Prata: {
                label: "Ouro",
                total: 101
            },
            Ouro: {
                label: "Embaixador",
                total: 1001
            }
        };

        const nextMissingImpactLevel =
            engagementNextLevel[
                this.engagement?.nextImpactLevel?.status || "Bronze"
            ] || {};
        const total = this.engagement?.companiesIdsImpact.length + 1;
        const missingImpact = this.engagement?.nextImpactLevel.total - total;
        const nextMissingImpactLevelTotal = nextMissingImpactLevel?.total || 0;
        const missingNextImpactTotal = nextMissingImpactLevelTotal - total;

        this.engagement.total = total;
        this.engagement.missingImpact = missingImpact < 0 ? 0 : missingImpact;
        nextMissingImpactLevel.missingNextImpactTotal =
            missingNextImpactTotal < 0 ? 0 : missingNextImpactTotal;
        this.engagement.nextMissingImpactLevel = nextMissingImpactLevel;

        if (missingImpact >= 1) {
            this.updateImpact();
            this.onImpactAchieved();
        } else if (total <= 1000) {
            this.nextTheLevelMissionNucontDialog();
        }

        this._getEngagement();
    }

    async _getEngagement() {
        const currentDate = new Date();

        const engagement = await this.Report.getEngagementByAccountingId({
            accountingId: this.accountingId,
            date: {
                month: currentDate.getUTCMonth() + 1,
                year: currentDate.getUTCFullYear()
            }
        });

        this.engagement = engagement;
    }

    async copyLinkReport() {
        this.shared = true;
        const baseUrl = publicSettings.url;
        const { token, userAnonymous } = await this._generateToken();
        await this._onPushSharedReport(userAnonymous._id);
        const uri = `${baseUrl}/relatorio/${this.$stateParams.id}/${
            this.$stateParams.accountingId
        }/${this._typeReport()}/${userAnonymous._id}/${
            this.$stateParams.reportId
        }?liveToken=${token}`;
        navigator.clipboard.writeText(uri);
        this.ShareHistory.setReportShareHistory(
            "link",
            this.$stateParams.reportId,
            "USER_LINK"
        );
        this._showToastCopy();
        this.controllerPop.enabled = false;
        this.Events.send(
            `Relatorio.Compartilhar.CopiarLink.${SourceConvert.toHuman(
                this.report.sources
            )}`
        );
        this.missionLevelUpDialog();
        this.EventScore.onReportShared(
            this.$stateParams.accountingId,
            this.companyData._id,
            this.report.sources
        );
    }

    openPopBottom(type = "shareReport") {
        if (type === "feedback")
            return (this.controllerPop.feedback = this.controllerPop.feedback
                ? false
                : true);
        this.controllerPop.enabled = this.controllerPop.enabled ? false : true;
    }

    _showToastCopy() {
        this.toast.show("", "bottom right", {
            hideDelay: 1000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Link copiado com sucesso!",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    async _generateToken() {
        const getUserUsecase = new GetUserUsecase();
        const userAnonymous = await getUserUsecase.execute({
            username: AnonymousUser.email
        });
        const token = userAnonymous.getLastToken();
        return { token, userAnonymous: userAnonymous.props };
    }

    async sendWhatSapp() {
        const { token, userAnonymous } = await this._generateToken();
        this.historyShared = true;
        this._onPushSharedReport(userAnonymous._id);
        this.Events.send(
            `Relatorio.Compartilhar.Whatsapp.${SourceConvert.toHuman(
                this.report.sources
            )}`
        );
        this.EventScore.onReportShared(
            this.$stateParams.accountingId,
            this.companyData._id,
            this.report.sources
        );
        this.missionLevelUpDialog();
        const baseUrl = publicSettings.url;
        const uri = `${baseUrl}/relatorio/${this.$stateParams.id}/${
            this.$stateParams.accountingId
        }/${this._typeReport()}/${userAnonymous._id}/${
            this.$stateParams.reportId
        }?liveToken=${token}`;
        const whatsappAPI = "https://api.whatsapp.com/send?text=";
        const result = `${whatsappAPI} Olá, confira o Dash de performance que preparei da ${new URLSearchParams(
            escape(this.companyData.name)
        ).toString()} Clique no link abaixo para visualizar:\n ${uri}`;
        await this.ShareHistory.setReportShareHistory(
            "whatsapp",
            this.$stateParams.reportId,
            "USER_WHATSAPP"
        );
        window.open(result);
    }

    _typeReport() {
        return this.report.type;
    }

    share() {
        this.DSNDialogService.custom({
            controller: "DialogContainerShareCtrl as $ctrl",
            locals: {
                report: this.report,
                companyData: this.companyData,
                accountingId: this.accountingId,
                templateHtml: dialogContainerShareTemplate,
                width: "450px",
                onPrint: () => {
                    this.historyShared = true;
                    this.onPrint();
                    window.onafterprint = () => {
                        this.missionLevelUpDialog();
                    };
                },

                share: this.onShareReport
            },
            clickOutsideToClose: false,
            after: {
                hide: (printShared) => {
                    if (printShared) return;
                    this.missionLevelUpDialog();
                }
            }
        });
    }

    nextTheLevelMissionNucontDialog() {
        this.DSNDialogService.custom({
            controller: "NextTheLevelMissionNucontDialogCtrl as $ctrl",
            clickOutsideToClose: true,
            locals: {
                width: "451px",
                engagement: this.engagement,

                templateHtml: nextLevelMissionNucontTemplate
            },
            after: {
                hide: () => {},
                after: () => {}
            }
        });
    }
}

buttonShareComponent.$inject = [
    "$mdDialog",
    "DSNDialogService",
    "toast",
    "$stateParams",
    "$state"
];

const name = "buttonShareReport";
const def = {
    bindings: {
        report: "<",
        companyData: "<",
        accountingId: "<",
        onPrint: "<",
        historyShared: "=",
        hideFeedback: "<",
        showReport: "<",
        afterSend: "&",
        controllerPop: "=",
        anonymousUser: "<",
        verifyFeedback: "=",
        hideShared: "=",
        shared: "=",
        engagement: "<"
    },

    controller: buttonShareComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
